import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment as env } from '../../../../environments/environment'

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
    array_lenguage = env.array_lenguage;
    flag_select = env.language_default;
    constructor(public router: Router, public translate: TranslateService) { }

    ngOnInit(): void {}

    classApplied = false;
    toggleClass() {
        this.classApplied = !this.classApplied;
    }

    changeLanguage(language:any){
        env.language_default = language
        this.flag_select = language
        this.translate.use(env.language_default);
    }

}
